export default "__VITE_ASSET__CNXak5HS__";